/** Detect a Browser on iPhone device */
export default function isIPhone(ua) {
	return /iPhone/i.test(ua) && !/iPod/i.test(ua);
}
